module.exports = __webpack_public_path__ + "static/media/service1b.4e2557bc.png";